import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queries/keys';
import { BillingService, type CreditEstimateRequest } from '../services/billingService';
import { useAuthStore } from '../store/authStore';
import { nairaRateFromEstimate, type NairaRate } from './naira';

/**
 * The wallet's Naira per dollar for one lab and model, or null (no model, unpriced, or the estimate
 * failed — then no price shows, never the provider's). Signed out too: the quote is then the platform
 * price anyone would pay. One request per lab and
 * model, held ten minutes: the rate card changes rarely, and the rate is the same for every duration.
 */
export function useNairaRate(lab: CreditEstimateRequest['lab'], model: string | null | undefined): NairaRate | null {
  // In the key, so signing in re-asks: the caller's own key can turn the price into ₦0.
  const isSignedIn = useAuthStore((s) => s.isAuthenticated);
  const { data } = useQuery({
    queryKey: [...queryKeys.nairaRate(lab, model ?? ''), isSignedIn],
    queryFn: () => BillingService.estimate({ lab, model: model!, quantity: 1 }),
    enabled: !!model,
    staleTime: 10 * 60_000,
    retry: false,
  });
  return nairaRateFromEstimate(data);
}
